export const CircularProgress = ({ percentage }: { percentage: number }) => {
  const radius = 9;
  const circumference = 2 * Math.PI * radius;

  const validPercentage = isNaN(Number(percentage)) ? 0 : Number(percentage);
  const strokeDashoffset =
    circumference - (validPercentage / 100) * circumference;
  const validOffset = isNaN(strokeDashoffset) ? 0 : strokeDashoffset;

  return (
    <div className="relative w-6 h-6 flex items-center justify-center">
      <svg className="w-full h-full transform -rotate-90">
        <circle
          cx="12"
          cy="12"
          r={radius}
          stroke="#E2E8F0"
          strokeWidth="2.5"
          fill="transparent"
        />
        <circle
          cx="12"
          cy="12"
          r={radius}
          stroke="#10B981"
          strokeWidth="2.5"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={validOffset}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
